export const imagesClockRoom = [
    {
       src: "https://res.cloudinary.com/durvgxd0n/image/upload/v1761911724/JT3A3299_rei0n7.jpg",
       original: "https://res.cloudinary.com/durvgxd0n/image/upload/v1761911724/JT3A3299_rei0n7.jpg",
       width: 320,
       caption: "Back of clock showing old window frame",
    },
    {
       src: "https://res.cloudinary.com/durvgxd0n/image/upload/v1761911723/JT3A3298_wues0t.jpg",
       original: "https://res.cloudinary.com/durvgxd0n/image/upload/v1761911723/JT3A3298_wues0t.jpg",
       width: 320,
       caption: "Back of clock showing old clock face cutout",
    },
    {
       src: "https://res.cloudinary.com/durvgxd0n/image/upload/v1761911722/JT3A3297_et04lg.jpg",
       original: "https://res.cloudinary.com/durvgxd0n/image/upload/v1761911722/JT3A3297_et04lg.jpg",
       width: 320,
       caption: "Back of clock showing old clock face cutout",
    },
    {
       src: "https://res.cloudinary.com/durvgxd0n/image/upload/v1761911722/JT3A3296_mnkgit.jpg",
       original: "https://res.cloudinary.com/durvgxd0n/image/upload/v1761911722/JT3A3296_mnkgit.jpg",
       width: 640,
       height: 427,
       caption: "West side window frame",
    },
    {
       src: "https://res.cloudinary.com/durvgxd0n/image/upload/v1761911720/JT3A3291_u6wgjh.jpg",
       original: "https://res.cloudinary.com/durvgxd0n/image/upload/v1761911720/JT3A3291_u6wgjh.jpg",
       width: 320,
       height: 212,
       caption: "South side window frame",
    },
    {
       src: "https://res.cloudinary.com/durvgxd0n/image/upload/v1761911722/JT3A3294_trqfvc.jpg",
       original: "https://res.cloudinary.com/durvgxd0n/image/upload/v1761911722/JT3A3294_trqfvc.jpg",
       width: 320,
       height: 212,
       caption: "Lintel in-situ",
    },
    {
       src: "https://res.cloudinary.com/durvgxd0n/image/upload/v1761911720/JT3A3290_rfzwom.jpg",
       original: "https://res.cloudinary.com/durvgxd0n/image/upload/v1761911720/JT3A3290_rfzwom.jpg",
       width: 320,
       height: 212,
       caption: "Axe side-on",
    },
    {
       src: "https://res.cloudinary.com/durvgxd0n/image/upload/v1761911721/JT3A3292_pfgm83.jpg",
       original: "https://res.cloudinary.com/durvgxd0n/image/upload/v1761911721/JT3A3292_pfgm83.jpg",
       width: 320,
       height: 212,
       caption: "Axe from below",
    },
    ];